import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class ProductGroupService {
    private apiUrl = `${environment.apiUrl}/sellerProductGroup`;

    constructor(private http: HttpClient) { }


    post(model: any): Observable<any> {
        return this.http.post(this.apiUrl, model, { observe: 'response' });
    }

    update(id: string | null, model: any): Observable<any> {

        let url = `${this.apiUrl}/${id}`;
        return this.http.put(url, model, { observe: 'response' });
    }

    getById(id: string): Observable<any> {
        let url = `${this.apiUrl}/${id}`;

        return this.http.get(url, { observe: 'response' }).pipe(
            map(response => {
                if (response.status !== 200)
                    throw new Error('Erro ao buscar grupo de produtos.');
                return response.body;
            })
        )
    }
    get(name?: string, inactive?: any): Observable<any> {
        let url = `${this.apiUrl}?`;

        if (name)
            url = `${url}&name=${name}`;

        if (inactive)
            url = `${url}&inactive=${inactive}`;

        return this.http.get(url, { observe: 'response' }).pipe(
            map(response => {
                if (response.status !== 200)
                    throw new Error('Erro ao buscar grupo de produtos.');
                return response.body;
            })
        )
    }

    activeOrInactive(productGroupId: string, inactive: boolean): Observable<any> {
        let url = `${this.apiUrl}/${productGroupId}`;
        if (inactive)
            url = `${url}/active`;
        else
            url = `${url}/inactive`;

        return this.http.patch(url, null, { observe: 'response' });
    }
}
